import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { User, Lock, AlertCircle, Loader2 } from 'lucide-react';
import { motion } from 'framer-motion';
import api from '../../services/api';

export default function InfluencerRegister() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const navigate = useNavigate();
  const { login: authLogin } = useAuth();

  const [pseudo, setPseudo] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (password !== confirmPassword) { setError('Les mots de passe ne correspondent pas'); return; }
    if (password.length < 8) { setError('Le mot de passe doit contenir au moins 8 caractères'); return; }
    setLoading(true);
    try {
      const res = await api.post('/influencers/register', { token, pseudo, password });
      localStorage.setItem('auth_token', res.data.access_token);
      window.location.href = '/influencer';
    } catch (err) {
      setError(err.response?.data?.detail || "Erreur lors de l'inscription");
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <div className="min-h-screen flex items-center justify-center px-4">
        <div className="bg-[#1A1A1D] p-8 rounded-lg metallic-border text-center max-w-md">
          <AlertCircle className="h-12 w-12 text-[#FF3B5C] mx-auto mb-4" />
          <h2 className="text-xl font-bold text-white mb-2">Lien invalide</h2>
          <p className="text-[#B8B8BA] text-sm">Ce lien d'invitation est invalide ou a expiré. Contactez l'administrateur.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center px-4 py-12" data-testid="influencer-register-page">
      <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} className="w-full max-w-md">
        <div className="bg-[#1A1A1D] p-8 rounded-lg metallic-border">
          <div className="text-center mb-8">
            <h1 className="text-2xl font-bold text-white mb-2">Créer mon compte influenceur</h1>
            <p className="text-[#B8B8BA] text-sm">Rejoignez le programme influenceur IPTV4KFR</p>
          </div>
          {error && (
            <div className="bg-[#FF3B5C]/10 border border-[#FF3B5C]/30 p-3 rounded-lg mb-4 flex items-center gap-2">
              <AlertCircle className="h-4 w-4 text-[#FF3B5C] shrink-0" />
              <p className="text-[#FF3B5C] text-sm">{error}</p>
            </div>
          )}
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="text-[#B8B8BA] text-xs font-semibold uppercase tracking-wider mb-1 block">Pseudo (nom public)</label>
              <div className="relative">
                <User className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-[#6B6B6E]" />
                <input type="text" value={pseudo} onChange={(e) => setPseudo(e.target.value)} required minLength={2} maxLength={50}
                  className="w-full bg-[#222226] border border-[#3A3A3D] rounded-lg pl-10 pr-4 py-3 text-white text-sm focus:border-[#FF6B35] focus:outline-none" placeholder="Votre pseudo" data-testid="register-pseudo" />
              </div>
            </div>
            <div>
              <label className="text-[#B8B8BA] text-xs font-semibold uppercase tracking-wider mb-1 block">Mot de passe</label>
              <div className="relative">
                <Lock className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-[#6B6B6E]" />
                <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={8}
                  className="w-full bg-[#222226] border border-[#3A3A3D] rounded-lg pl-10 pr-4 py-3 text-white text-sm focus:border-[#FF6B35] focus:outline-none" placeholder="Min. 8 caractères" data-testid="register-password" />
              </div>
            </div>
            <div>
              <label className="text-[#B8B8BA] text-xs font-semibold uppercase tracking-wider mb-1 block">Confirmer le mot de passe</label>
              <div className="relative">
                <Lock className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-[#6B6B6E]" />
                <input type="password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} required
                  className="w-full bg-[#222226] border border-[#3A3A3D] rounded-lg pl-10 pr-4 py-3 text-white text-sm focus:border-[#FF6B35] focus:outline-none" placeholder="Confirmer" data-testid="register-confirm" />
              </div>
            </div>
            <button type="submit" disabled={loading} className="w-full btn-primary py-3 flex items-center justify-center gap-2 disabled:opacity-50" data-testid="register-submit">
              {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : 'Créer mon compte'}
            </button>
          </form>
        </div>
      </motion.div>
    </div>
  );
}
